import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

export const DASHBOARD_THEME_CHANGE_EVENT = 'dashboard:theme-changed';

export const isDarkThemeEnabled = () =>
  document.body.classList.contains('dark');

export const setColorTheme = isOSOnDarkMode => {
  const selectedColorScheme =
    LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'auto';
  if (
    (selectedColorScheme === 'auto' && isOSOnDarkMode) ||
    selectedColorScheme === 'dark'
  ) {
    document.body.classList.add('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
  } else {
    document.body.classList.remove('dark');
    document.documentElement.style.setProperty('color-scheme', 'light');
  }

  window.dispatchEvent(
    new CustomEvent(DASHBOARD_THEME_CHANGE_EVENT, {
      detail: { isDark: isDarkThemeEnabled() },
    })
  );
};
